const isObject = <T>(value: unknown): value is T =>
  typeof value === 'object' && value !== null

export const reactNodeIsOfType = <
  P extends Record<string, unknown>,
  T extends { (props: P): React.ReactElement | null | undefined }
>(
  node: React.ReactNode,
  type: T
): node is { key: React.Key | null; type: T; props: Parameters<T>[0] } =>
  isObject<React.ReactElement>(node) && node.type === type
